var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('LoginCard',[(!_vm.onConfirm & !_vm.onMFA)?_c('LoginDefault',{on:{"toggle-on-confirm":function (authDetails) {
          this$1.authDetails = authDetails;
          _vm.onConfirm = true;
        },"toggle-on-mfa":function (authDetails) {
          this$1.authDetails = authDetails;
          _vm.onMFA = true;
        }}}):_vm._e(),(_vm.onConfirm)?_c('RegisterConfirm',{attrs:{"authDetails":_vm.authDetails},on:{"toggle-on-confirm":function($event){_vm.onConfirm = false}}}):_vm._e(),(_vm.onMFA)?_c('Register2FA',{attrs:{"authDetails":_vm.authDetails}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }